/** OutputPanel の行分割と差分（純粋関数）。HTML は作らず、描画側が要素に組み立てる */

export interface OutputLine {
  /** 末尾空白を除いた本文 */
  text: string;
  /** 末尾の空白（タブを含む）の個数 */
  trailing: number;
  /** 相手側の同じ行と異なるか */
  changed: boolean;
  /** 最後の行でなく、改行で終わるか */
  eol: boolean;
}

export function splitLines(s: string): string[] {
  const normalized = s.replace(/\r\n/g, '\n');
  if (normalized === '') return [];
  const lines = normalized.split('\n');
  // 末尾の改行 1 つは行として数えない
  if (lines.length > 1 && lines[lines.length - 1] === '') lines.pop();
  return lines;
}

function toLine(raw: string, changed: boolean, eol: boolean): OutputLine {
  const m = /[ \t]+$/.exec(raw);
  const trailing = m ? m[0].length : 0;
  return { text: raw.slice(0, raw.length - trailing), trailing, changed, eol };
}

/** 行ごとに比べる。比較は末尾空白を含む生の行で行う（空白の違いも見せるため） */
export function diffLines(
  expected: string,
  actual: string,
): { expected: OutputLine[]; actual: OutputLine[] } {
  const e = splitLines(expected);
  const a = splitLines(actual);
  const endsE = expected.endsWith('\n');
  const endsA = actual.endsWith('\n');
  return {
    expected: e.map((l, i) => toLine(l, a[i] !== l, i < e.length - 1 || endsE)),
    actual: a.map((l, i) => toLine(l, e[i] !== l, i < a.length - 1 || endsA)),
  };
}

export function plainLines(s: string): OutputLine[] {
  const lines = splitLines(s);
  const ends = s.endsWith('\n');
  return lines.map((l, i) => toLine(l, false, i < lines.length - 1 || ends));
}

/** stderr から viz 補助の行（`@@viz` で始まる行）を取り除く */
export function stripVizLines(stderr: string): string {
  return stderr
    .split('\n')
    .filter((l) => !l.startsWith('@@viz'))
    .join('\n');
}
